
export const CC_LINK = 'https://www.clickcease.com/dashboard';